import request from '@/utils/request/index';

export function listNotifications(parameter) {
    return request({
        url: '/notifications/page',
        method: 'GET',
        params: parameter
    });
}

export function read(id) {
    return request({
        url: `/notifications/${id}/read`,
        method: 'PUT'
    });
}

export function readAll() {
    return request({
        url: `/notifications/read-all`,
        method: 'PUT'
    });
}

export function listUnreadNotifications() {
    return request({
        url: `/notifications/unread`,
        method: 'GET'
    });
}

export function count() {
    return request({
        url: `/notifications/unreadCount`,
        method: 'GET'
    });
}
